module.exports = __webpack_public_path__ + "img/Forest.02888421.png";